<template>
  <div class="mx-auto bg-white min-h-screen">
    <modal-confirm
      :showModal="modal"
      :modalData="modalData"
      @cancel="modal = false"
      @confirm="setAbsence"
    ></modal-confirm>
    <modal-confirm
      :showModal="deleteAbsenceModal"
      :modalData="modalData"
      @cancel="deleteAbsenceModal = false"
      @confirm="deleteAbsence"
    ></modal-confirm>
    <div>
      <div class="px-8">
        <Sidebar></Sidebar>
        <Header>{{$t('all.scheduled_absences')}} {{$route.query.className}}
        </Header>
        <div
          class="pt-6 pb-20"
          v-if="!modal && !deleteAbsenceModal"
        >
          <div class="fixed pin-l w-full mx-auto my-6 bg-red z-30 shadow">
            <div class="container py-3 mx-5">
              <div class="flex justify-start mx-3">
                <div
                  :class="isToday ? 'bg-white text-pink-dark' : 'bg-pink-dark'"
                  @click="onChangeMode(true)"
                  class="text-white w-1/3 text-center inline-block text-xs py-1 px-1 hover:text-pink-dark hover:bg-white font-semibold"
                >
                  {{$t('all.today')}}
                </div>
                <div
                  :class="!isToday ? 'bg-white text-pink-dark' : 'bg-pink-dark'"
                  @click="onChangeMode(false)"
                  class="text-white w-1/3 text-center inline-block text-xs py-1 px-1 ml-2 hover:text-pink-dark hover:bg-white font-semibold"
                >
                  {{$t('all.scheduled')}}
                </div>
              </div>
            </div>
          </div>
          <div class="flex pt-24 pb-3">
            <div class="flex-1 pr-4">
              <p class="text-xs pb-1 font-semibold text-pink-dark">{{$t('all.from')}}</p>
              <div>
                <div class="relative">
                  <datepicker
                    :disabled="isToday"
                    :disabledDates="startDisabledDates"
                    :format="format"
                    :language="languages[$i18n.locale]"
                    :mondayFirst="true"
                    v-model="startDate"
                    :inputClass="'bg-pink-dark text-center text-white p-1 w-full text-sm block outline-none appearance-none px-4 pr-8'"
                  ></datepicker>
                  <div class="absolute pin-y pin-r flex items-center px-2 text-white">
                    <i class="far fa-calendar-alt fa-xs"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-1">
              <p class="text-xs pb-1 font-semibold text-pink-dark">{{$t('all.to')}}</p>
              <div>
                <div class="relative">
                  <datepicker
                    :disabled="isToday"
                    :disabledDates="endDisabledDates"
                    :language="languages[$i18n.locale]"
                    :mondayFirst="true"
                    :format="format"
                    v-model="endDate"
                    calendarClass="pin-r"
                    :inputClass="'bg-pink-dark right-input text-center text-white p-1 w-full text-sm block outline-none appearance-none px-4 pr-8'"
                  ></datepicker>
                  <div class="absolute pin-y pin-r flex items-center px-2 text-white">
                    <i class="far fa-calendar-alt fa-xs"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="bg-pink-dark px-3 py-4 rounded-full w-full shadow-custom"
            @click="openModal"
          >
            <p class="text-white uppercase text-center text-xs"><b>{{$t('all.confirm_absence')}}</b></p>
          </div>
          <div class="pt-3">
            <div
              class="block"
              v-for="absence in absences"
              :key="absence.id"
            >
              <div class="flex py-2 border-b-2 border-dashed border-pink">
                <div class="w-4/5">
                  <h4 class="text-sm pb-1">{{$t('all.class_absence')}} {{$t('all.of')}} {{ $d($moment(absence.date), 'short') }}</h4>
                  <p class="text-sm text-grey">{{ absence.classroom.institute.name }}</p>
                </div>
                <div class="pt-2 text-right w-1/5"
                  @click="removeAbsenceModal(absence)">
                  <i class="fa fa-times text-red fa-lg"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';

export default {
  name: 'ScheduledAbsence',
  data() {
    return {
      isToday: true,
      startDate: new Date(),
      endDate: new Date(),
      modal: false,
      modalData: {
        text: '',
      },
      absenceId: null,
      deleteAbsenceModal: false,
      format: 'dd/MM/yyyy',
      startDisabledDates: {
        to: new Date(),
        from: null,
      },
      endDisabledDates: {
        to: new Date(),
        from: null,
      },
      languages: lang,
    };
  },
  watch: {
    startDate(val) {
      if (val > this.endDate) {
        this.endDate = this.startDate;
        this.endDisabledDates.to = this.startDate;
      }
      this.endDisabledDates.to = this.startDate;
    },
  },
  methods: {
    ...mapActions('minor', [
      'setScheduledAbsence',
      'getAbsences',
      'removeAbsence',
    ]),
    openModal() {
      this.modalData.text = `${this.$t('all.areYouSureToConfirmAbsenceModal')}`;
      this.modal = true;
    },
    onChangeMode(value) {
      this.isToday = !!value;
      if (this.isToday) {
        this.startDate = new Date();
        this.endDate = new Date();
      }
    },
    setAbsence() {
      const id = this.$route.params.id;
      const classroom = this.$route.query.classe;
      const data = {
        dateFrom: this.$moment(this.startDate).format('YYYY-MM-DD'),
        dateTo: this.$moment(this.endDate).format('YYYY-MM-DD'),
      };
      this.setScheduledAbsence({
        minor_id: id,
        classroom,
        data,
      })
        .then(() => {
          console.log('success');
          this.getAbsences({
            minor_id: id,
            classroom_id: classroom,
          });
          this.modal = false;
        })
        .catch((error) => {
          this.modal = false;
        });
    },
    removeAbsenceModal(item) {
      this.absenceId = item.id;
      this.modalData.text = `${this.$t('all.areYouSureToRemoveAbsenceModal')} <b>${this.$d(this.$moment(item.parsedDate), 'short')}</b> ?`;
      this.deleteAbsenceModal = true;
    },
    deleteAbsence() {
      const id = this.$route.params.id;
      const classroom = this.$route.query.classe;
      this.removeAbsence({ id: this.absenceId }).then(() => {
          this.getAbsences({
            minor_id: id,
            classroom_id: classroom,
          });
          this.deleteAbsenceModal = false;
        })
        .catch((error) => {
          this.deleteAbsenceModal = false;
        });
    }
  },
  computed: {
    ...mapGetters({
      absences: 'minor/absencesList',
    }),
  },
  created() {
    this.startDisabledDates.to.setDate(this.startDate.getDate() - 1);
    this.endDisabledDates.to.setDate(this.endDate.getDate() - 1);
    this.getAbsences({
      minor_id: this.$route.params.id,
      classroom_id: this.$route.query.classe,
    });
  },
  components: {
    Datepicker,
  },
};
</script>
<style lang="scss">
.cell.day:not(.disabled) {
  &:hover,
  &.selected,
  &.highlighted {
    background: #ee6f56;
    border: 1px solid #ee6f56 !important;
    border-radius: 100%;
    color: white;
  }
}
.vdp-datepicker__calendar .cell.selected {
  background: #ee6f56;
  border: 1px solid #ee6f56 !important;
  color: white;
}
</style>
